<template>
    <div class="checkbox" :class="{disabled: disabled, invalid: invalid}">
        <label 
            :for="id" 
            class="pppp-label">
            <input 
                v-model="value"
                type="checkbox" 
                :id="id" 
                :name="id" 
                class="pppp-checkbox" 
                :required="required" 
                :disabled="disabled" />
                {{ getLabel }} 
                <span class="pppp-validation-msg">
                    <span class="glyphicon glyphicon-exclamation-sign"></span> Tämä kenttä on pakollinen!
                </span>
        </label>
    </div>
</template>

<script>
export default {
    name: 'FormCheckbox',
    props: {
        modelValue: Boolean,
        id:  String,
        label: String,
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    computed: {
        getLabel() {
            if (this.required) {
                return '* ' + this.label;
            }
            return this.label;
        },
        invalid() {
            return this.required && ! this.value;
        },
        value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    }
}
</script>

<style scoped>
.pppp-checkbox {
    margin-top: 7px !important;
}
</style>
